const AsyncStatus = {
  unfetched: "UNFETCHED",
  pending: "PENDING",
  success: "SUCCESS",
  failed: "FAILED",
};

export default AsyncStatus;
